import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Typography
} from '@mui/material';
import {
  Close,
  Description,
  Article
} from '@mui/icons-material';
import { useAppSettings } from '../../hooks/useGlobalSettings';

interface LegalDocumentModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  pdfPath?: string;
  htmlPath?: string;
}

const LegalDocumentModal: React.FC<LegalDocumentModalProps> = ({ open, onClose, title, pdfPath, htmlPath }) => {
  const { appName } = useAppSettings();

  // Determine if we should use HTML or PDF
  const useHtml = htmlPath && !pdfPath;
  const documentPath = useHtml ? htmlPath : pdfPath;
  const isHtml = useHtml || (documentPath && documentPath.endsWith('.html'));

  // Add app name as URL parameter for HTML documents
  const getDocumentUrl = () => {
    if (isHtml && documentPath) {
      const separator = documentPath.includes('?') ? '&' : '?';
      return `${documentPath}${separator}appName=${encodeURIComponent(appName)}`;
    }
    return documentPath;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          height: isHtml ? '95vh' : '90vh'
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {isHtml ? <Article color="primary" /> : <Description color="primary" />}
            <Typography variant="h6">
              {title}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 0, height: '100%' }}>
        <Box sx={{ width: '100%', height: '100%' }}>
          {isHtml ? (
            <iframe
              src={getDocumentUrl()}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title={title}
              sandbox="allow-same-origin allow-scripts"
            />
          ) : (
            <iframe
              src={getDocumentUrl()}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title={title}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LegalDocumentModal;